export interface ListHelpPageOption {
  value: string;
  label: string;
}

/**
 * 常见问题可选页面。
 *
 * 仅收录当前后台中适合挂载常见问题按钮的数据列表页，避免让用户手动记内部标识。
 */
export const LIST_HELP_PAGE_OPTIONS: ListHelpPageOption[] = [
  { value: 'order_management', label: '业务订单' },
  { value: 'trademark_monitor', label: '商标监控' },
  { value: 'status_translation', label: '状态翻译' },
  { value: 'follow_up_management', label: '客户跟进' },
  { value: 'fee_management', label: '最新报价' },
  { value: 'patent_payment_management', label: '专利年费监控' },
  { value: 'document_management', label: '文档管理' },
  { value: 'media_library', label: '媒体库' },
  { value: 'user_management', label: '用户管理' },
  { value: 'notification_management', label: '通知模板' },
  { value: 'system_logs', label: '系统日志' },
];

export const get_list_help_page_label = (page_key: string): string => {
  return LIST_HELP_PAGE_OPTIONS.find((item) => item.value === page_key)?.label || page_key;
};
